import { useLazyQuery } from "@apollo/client";
import { Select, message } from "antd";
import { get } from "lodash";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { GQL_CER_CODES } from "../../apollo/query/common";
import { useDebouncedCallback } from "use-debounce/lib";
import { debounceSearchFilterDelay } from "../../util/config";

const CerCodesSelect = ({ familyCodes, minLength, defaultItem, ...rest }) => {
   const intl = useIntl();
   const [filter, setFilter] = useState(null);
   const [loadCodes, { loading }] = useLazyQuery(GQL_CER_CODES);
   const [results, setResults] = useState(defaultItem ? [defaultItem] : []);

   const fetchData = (term) => {
      loadCodes({
         variables: {
            input: {
               family_codes: familyCodes ?? [],
               term,
            },
         },
      })
         .then((response) => setResults(get(response, "data.cerCodes", [])))
         .catch((error) => {
            message.error(error.message);
         });
   };

   const debouncedFilterCallback = useDebouncedCallback(
      (term) => fetchData(term),
      debounceSearchFilterDelay
   );

   let placeholder = intl.formatMessage({ id: "waste.select_type" });
   if (minLength) {
      placeholder += ` (${intl.formatMessage(
         { id: "common.min_n_char" },
         { num: minLength }
      )})`;
   }

   return (
      <>
         <Select
            searchValue={filter ?? ""}
            onClear={() => setFilter(null)}
            filterOption={false}
            onSearch={(value) => {
               setFilter(value);
               if (value && (!minLength || value.length >= minLength)) {
                  debouncedFilterCallback(value);
               } else {
                  setResults([]);
               }
            }}
            loading={loading}
            allowClear
            showSearch
            placeholder={placeholder}
            {...rest}
         >
            {(results || []).map((result, idx) => (
               <Select.Option
                  value={result.id}
                  key={`sel-cer-codes-${idx}`}
                  code={result.code}
                  description={result.description}
                  style={{ height: "auto" }}
               >
                  <div>
                     <span className="gx-mr-1 gx-text-dark">{result.code}</span>
                     <small>{result.description}</small>
                  </div>
               </Select.Option>
            ))}
         </Select>
      </>
   );
};

CerCodesSelect.defaultProps = {
   minLength: 2,
};

export default CerCodesSelect;
